export enum IndicatorUpdateTypes {
  Numeric = 1,
  Pass_Or_Fail = 2,
}
